import React, { useContext, useEffect, useState } from "react";
import { putData } from "../../lib/utils";
import { Context } from "../contexts/AppContext";
function DomainSetting() {


     const { value } = useContext(Context);
     
        const [appState, setAppState] = value;
  const [domain, setDomain] = useState(""); // input ka value
  const [savedDomain, setSavedDomain] = useState(""); // jo domain add hoga

  useEffect(()=>{
setSavedDomain(appState?.adminDetails?.domainurl)
  },[appState?.adminDetails?.domainurl])
const handleAddDomain = async () => {
  console.log("app state ",appState)
    if (domain.trim() !== "" && appState?.adminDetails?.id) {
      try {
        const obj = { domainurl: domain.trim() };

        const res = await putData(`admin/update-domain/${appState?.adminDetails?.id}`, obj);

        if (res) {
          console.log("reposne... ",res)
          setSavedDomain(domain.trim());
          setDomain(""); // input clear
        }
      } catch (error) {
        console.error("Error updating domain:", error);
      }
    }
  };

  const handleRemoveDomain = async() => {
    setSavedDomain("");
    const obj={
      domainurl:null
    }
      const res = await putData(`admin/update-domain/${appState?.adminDetails?.id}`, obj);

        if (res) {
          console.log("reposne... ",res)
            setSavedDomain("");
          setDomain(""); // input clear
        }
  };

  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 text-left">
        {/* Left Section */}
        <div className="bg-white rounded-2xl shadow-md border">
          <div className="p-5 border-b">
            <h2 className="text-lg font-semibold">Custom Domain</h2>
            <p className="text-sm text-gray-500">
              Use your own custom domain for your client galleries:
            </p>
          </div>
          <div className="p-5">
            <div className="border p-4 rounded-lg">
              {savedDomain ? (
                <>
                  {/* Domain Active UI */}
                  <div className="text-lg font-medium">{savedDomain}</div>

                  <div className="flex items-center justify-between mt-3 p-3 border rounded-lg bg-green-50">
                    <div>
                      <p className="font-medium text-green-700">
                        Your domain is active.
                      </p>
                      <p className="text-sm text-gray-500">
                        DNS changes can take up to 48 hours to propagate across
                        the entire internet.
                      </p>
                    </div>
                  </div>

                  <button
                    onClick={handleRemoveDomain}
                    className="mt-4 w-full border border-red-500 text-red-600 rounded-lg py-2 hover:bg-red-50 transition"
                  >
                    Remove Domain
                  </button>
                </>
              ) : (
                <>
                  {/* Input + Add Domain UI */}
                  <input
                    type="text"
                    value={domain}
                    onChange={(e) => setDomain(e.target.value)}
                    placeholder="Enter your domain"
                    className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <button
                    onClick={handleAddDomain}
                    className="mt-3 w-full bg-blue-600 text-white rounded-lg py-2 hover:bg-blue-700 transition"
                  >
                    Add Domain
                  </button>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="bg-white rounded-2xl shadow-md border p-5 lg:col-span-2 overflow-y-auto h-screen">
          <div className="mb-2 font-semibold">SETUP INSTRUCTIONS</div>
          <p className="text-sm text-gray-500 mb-3">
            Use the guide below to setup your custom domain:
          </p>

          {/* --- Baki content same rahega (steps, images, etc.) --- */}
            <section id="main-content" className="w-full mx-auto p-6">
            <div className="bg-white rounded-lg shadow-sm p-6">
        <article id="fullArticle">
          {/* Title & Print */}
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold">Setting up Custom Domain</h1>
          {/*  <button
              onClick={() => window.print()}
              title="Print this article"
              aria-label="Print this Article"
              className="text-gray-500 hover:text-gray-700"
            >
              🖨️
            </button>*/}
          </div>

          {/* Hero image */}
          <p className="mt-4">
            <img
              src="//d33v4339jhl8k0.cloudfront.net/docs/assets/618b38426a8a6772ed86a6fb/images/681b98acdcf9fb1ef6c97e72/file-k5XOLOKKwX.png"
              alt="Custom Domain Setup"
              className="max-w-full rounded-md"
            />
          </p>

          {/* Introduction */}
          <p className="mt-6">
            You can link your custom domain to your VidFlix Client Galleries in a few quick steps.
          </p>
          <p>
            <b>Domain Required</b> – If you have not purchased a domain, you can purchase one from
            a 3rd-party domain provider such as GoDaddy, Squarespace, Google Domains or others.
          </p>

          <blockquote className="border-l-4 border-blue-500 pl-4 my-4 text-gray-700">
            For On-Demand customers, the{" "}
            <a
              href="https://VidFlix.co/add-ons.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline"
            >
              <b>White-labeling Add-on</b>
            </a>{" "}
            is required.
          </blockquote>

          {/* Step 1 */}
          <h3 className="text-xl font-semibold mt-6">Step 1 – Log into your domain provider / DNS host</h3>
          <p className="mt-2">
            Log into the dashboard where your domain or DNS is hosted, and go to your DNS settings.
          </p>
          <blockquote className="border-l-4 border-yellow-500 pl-4 my-4 text-gray-600 text-sm">
            Note: Do not delete any MX records during this process. MX records manage your email
            address. Deleting them will interrupt your email service.
          </blockquote>

          <hr className="my-6 border-gray-300" />

          {/* Step 2 */}
          <h3 className="text-xl font-semibold">Step 2 – Create a CNAME record</h3>
          <p className="mt-2">Add a new CNAME record. You’ll typically see the following fields:</p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Type – CNAME</li>
            <li>Host / Name / Alias – Enter a subdomain name of your choice.</li>
            <li>
              Points To – <b>vf-pro.VidFlix.co.</b>
            </li>
            <li>TTL – 1 Hour (or the minimum required)</li>
          </ul>

          <p className="mt-4 font-semibold">Examples:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>
              <b>client</b> – client.yourdomain.com
            </li>
            <li>
              <b>gallery</b> – gallery.yourdomain.com
            </li>
            <li>
              <b>galleries</b> – galleries.yourdomain.com
            </li>
            <li>
              <b>videos</b> – videos.yourdomain.com
            </li>
          </ul>

          <p className="mt-4">
            <img
              src="//d33v4339jhl8k0.cloudfront.net/docs/assets/618b38426a8a6772ed86a6fb/images/63026ea6502e69288e0e195f/file-uzvqVlgqxZ.png"
              alt="CNAME Example"
              className="rounded-md"
            />
          </p>

          <p className="mt-4">Adding a CNAME record if your domain is registered on:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>
              <a href="http://godaddy.com/help/add-a-cname-record-19236" className="text-blue-600 underline">
                GoDaddy
              </a>
            </li>
            <li>
              <a href="https://support.google.com/a/answer/47283?hl=en" className="text-blue-600 underline">
                Google Domains
              </a>
            </li>
            <li>
              <a
                href="https://support.squarespace.com/hc/en-us/articles/360002101888-Adding-custom-DNS-records-to-your-Squarespace-domain"
                className="text-blue-600 underline"
              >
                Squarespace
              </a>
            </li>
            <li>
              <a href="https://support.wix.com/en/article/adding-or-updating-cname-records-in-your-wix-account" className="text-blue-600 underline">
                Wix
              </a>
            </li>
            <li>
              <a
                href="https://www.namecheap.com/support/knowledgebase/article.aspx/9646/2237/how-to-create-a-cname-record-for-your-domain/"
                className="text-blue-600 underline"
              >
                Namecheap Domains
              </a>
            </li>
            <li>
              <a
                href="https://www.domain.com/help/article/dns-management-how-to-update-cname-aliases"
                className="text-blue-600 underline"
              >
                Domain.com
              </a>
            </li>
          </ul>

          {/* Step 3 */}
          <h3 className="text-xl font-semibold mt-6">Step 3 – Update your VidFlix Custom Domain</h3>
          <p className="mt-2">Log into your VidFlix Account and follow these steps:</p>
          <p>1. Go to <b>Company Settings</b> &gt; <b>Domain Settings</b></p>
          <p className="mt-2">
            <img
              src="//d33v4339jhl8k0.cloudfront.net/docs/assets/618b38426a8a6772ed86a6fb/images/62b1f593e13ae052a9d6937f/file-6wlPCHM6bk.png"
              alt="Company Settings"
              className="w-44 rounded-md"
            />
          </p>

          <p className="mt-2">
            2. Enter the same <b>domain URL</b> you created (e.g.{" "}
            <i>client.yourdomain.com</i>) and click <b>Save Domain</b>
          </p>
          <p>
            <img
              src="//d33v4339jhl8k0.cloudfront.net/docs/assets/618b38426a8a6772ed86a6fb/images/62b1f6e435a1630c11983bcd/file-AmliQDBMRJ.png"
              alt="Save Domain Example"
              className="max-w-full rounded-md"
            />
          </p>

          <p>3. Click <b>Verify</b> after completing Step 1 and Step 2.</p>
          <p>
            <img
              src="//d33v4339jhl8k0.cloudfront.net/docs/assets/618b38426a8a6772ed86a6fb/images/62b2005ea713c738b2978894/file-xDVUE3qvmW.png"
              alt="Verify Domain"
              className="max-w-full rounded-md"
            />
          </p>

          <p>4. Once active, your custom domain will show <b>Active</b> status.</p>
          <p>
            <img
              src="//d33v4339jhl8k0.cloudfront.net/docs/assets/618b38426a8a6772ed86a6fb/images/62b329ec87c5bb4d58df350a/file-XPyKUNp26h.png"
              alt="Active Domain Example"
              className="max-w-full rounded-md"
            />
          </p>

          <blockquote className="border-l-4 border-gray-400 pl-4 my-6 text-gray-600 italic">
            <b>Note:</b> DNS changes can take up to 48 hours to propagate across the entire internet.
          </blockquote>
        </article>

        {/* Ratings */}
        {/*
        <div className="mt-6 border-t pt-4">
          <span className="block text-gray-700 font-medium">Did this answer your question?</span>
          <div className="flex gap-4 mt-2">
            <button className="px-3 py-2 rounded bg-green-100 text-green-700 hover:bg-green-200">
              Yes 👍
            </button>
            <button className="px-3 py-2 rounded bg-red-100 text-red-700 hover:bg-red-200">
              No 👎
            </button>
          </div>
        </div>*/}

        {/* Footer */}
        <section className="mt-6 border-t pt-4 text-sm text-gray-600">
          <p>
            Still need help?{" "}
            <a href="#" onClick={() => window.Beacon("open")} className="text-blue-600 underline">
              Contact Us
            </a>
          </p>
          <time className="block mt-2 text-xs">Last updated on May 7, 2025</time>
        </section>
      </div>
    </section>
        </div>
      </div>
    </>
  );
}

export default DomainSetting;
